<nav class="navbar navbar-expand navbar-dark navbarStyles">
  <div class="navbar-collapse collapse flex-row justify-content-between">
    <div class="text-center navbarStyles__image">
      <img
        class="navImage"
        [routerLink]="['/webcliente/home']"
        [queryParams]="{ client: client }"
        alt="UST"
        width="40"
        height="40"
      />
    </div>
    <div>
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" [routerLinkActive]="['activeRoute']">
          <a
            class="nav-link"
            [routerLink]="['/webcliente/home']"
            [queryParams]="{ client: client }"
          >
            <span class="align-middle">{{
              'SIDEBAR.OFFERS' | translate | uppercase
            }}</span>
          </a>
        </li>
        <li class="nav-item" [routerLinkActive]="['activeRoute']">
          <a
            class="nav-link"
            [routerLink]="['/webcliente/services']"
            [queryParams]="{ client: client }"
          >
            <span class="align-middle">{{
              'PROFILE.WORKER.MENU.SERVICEST' | translate | uppercase
            }}</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="navbarStyles__searchbar">
      <div class="col-lg-6 col-md-10" *ngIf="isOfferPage">
        <ais-instantsearch [config]="configOffer" [hidden]="!showSearchBar">
          <front-app-autocompleteSeach></front-app-autocompleteSeach>
        </ais-instantsearch>
      </div>
      <div class="col-lg-6 col-md-10" *ngIf="!isOfferPage">
        <ais-instantsearch [config]="configService" [hidden]="!showSearchBar">
          <front-app-autocompleteSeach-service></front-app-autocompleteSeach-service>
        </ais-instantsearch>
      </div>
    </div>

    <div class="navbarStyles__usericon">
      <ul class="navbar-nav mr-auto">
        <li
          *ngIf="!currentUser?.isWorker"
          class="nav-item"
          [routerLinkActive]="['activeRoute']"
        >
          <div class="icons nav-link" [routerLink]="['/webcliente/register']">
            <span class="align-middle font-bold">{{
              'NAVBAR.BECOMEAWORKER' | translate
            }}</span>
          </div>
        </li>

        <li *ngIf="currentUser?.isWorker" class="nav-item workerModeTag">
          <span>{{ 'NAVBAR.WORKERMODE' | translate }} </span>
        </li>

        <li class="nav-item language dropdown">
          <a
            class="nav-flag dropdown-toggle d-flex justify-content-center"
            href="#"
            id="languageDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <img
              [src]="'assets/img/flags/' + currentLang.key + '.png'"
              [alt]="currentLang.name"
            />
          </a>
          <div
            class="dropdown-menu dropdown-menu-end"
            aria-labelledby="languageDropdown"
          >
            <ng-container *ngFor="let lang of appLanguages">
              <a
                *ngIf="currentLang.key !== lang.key"
                class="dropdown-item"
                (click)="updateLanguage(lang)"
              >
                <img
                  [src]="'assets/img/flags/' + lang.key + '.png'"
                  [alt]="lang.name"
                  width="20"
                  class="align-middle me-1"
                />
                <span class="align-middle">{{ lang.name }}</span>
              </a>
            </ng-container>
          </div>
          <!-- <app-dropdown-languages
            [addLanguage]="false"
            [readMode]="true"
            [availableTranslations]="appLanguages"
            (changeLanguage)="changeLang($event)"
          ></app-dropdown-languages> -->
        </li>
        <li class="nav-item" [routerLinkActive]="['activeRoute']">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="user menu"
            (menuClosed)="menuClosed()"
          >
            <mat-icon *ngIf="!currentUser?.image" style="color: white"
              >account_circle</mat-icon
            >
            <img
              *ngIf="currentUser?.image"
              class="userImg avatar img-fluid rounded-circle me-1"
              [src]="currentUser?.image?.image"
              alt="user image"
            />
          </button>
          <mat-menu #menu="matMenu">
            <!-- Form login -->
            <app-form-login
              [parentComponent]="'navbar'"
              *ngIf="!isUserLogin"
              #formLogin
            ></app-form-login>
            <!-- menu of worker -->
            <div id="loginUserMenu" class="m-3">
              <h1>{{ currentUser?.name }}</h1>
              <div *ngIf="currentUser?.isWorker" class="menuRow">
                <button
                  class="btn btn-primary-notdefault--active"
                  [routerLink]="['/webcliente/worker-home/worker-profile']"
                >
                  {{ 'NAVBAR.PROFILE' | translate }}
                </button>
              </div>
              <div *ngIf="currentUser?.isCustomer" class="menuRow">
                <button
                  class="btn btn-primary-notdefault--active"
                  [routerLink]="['/webcliente/customer-home/customer-profile']"
                >
                  {{ 'NAVBAR.PROFILE' | translate }}
                </button>
              </div>
              <div *ngIf="isUserLogin" class="menuRow">
                <button
                  class="btn btn-primary-notdefault--active"
                  (click)="signOut()"
                >
                  {{ 'NAVBAR.LOGOUT' | translate }}
                </button>
              </div>
            </div>

            <!-- menu of customer -->
          </mat-menu>
        </li>
      </ul>
    </div>
  </div>
</nav>
